import { useForm } from "react-hook-form";
import Filter from "./Filter"
import { Box, TextField } from "@mui/material";
export const FilterCompany = ({ onFilter }) => {

    const defaultValues = {
        id: "",
        name: "",
        document: "",
        email: "",
    }

    const methods = useForm({ defaultValues });

    return (
        <Filter onFilter={methods.handleSubmit(onFilter)} onClear={() => methods.reset(defaultValues)}>
            <Box display='flex' flexDirection='column' className='gap-1'>
                
                <TextField
                    id="id"
                    label="Id"
                    variant="outlined"
                    name="id"
                    {...methods.register("id")}
                />
                
                <TextField
                    id="name"
                    label="Nome"
                    variant="outlined"
                    name="name"
                    {...methods.register("name")}
                />

                <TextField
                    id="document"
                    label="Documento"
                    variant="outlined"
                    name="document"
                    {...methods.register("document")}
                />
                
                <TextField
                    id="email"
                    label="Email"
                    variant="outlined"
                    name="email"
                    {...methods.register("email")}
                />

            </Box>
        </Filter>

    )
}